<template>
  <div style="width: 100%;height: 100%;overflow: hidden">
    <div class="nothing-data" v-if="zonename.length === 0"></div>
    <div v-else style="height: 100%;width: 100%;margin: auto" id="bar" ref="wrap"></div>
  </div>
</template>

<script>
// import echarts from 'echarts'
import * as echarts from 'echarts'
export default {
  name: 'indexFamilyDevice',
  props: {
    familyDevice: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      familycount: [],
      devicecount: [],
      zonename: [],
      familyDeviceList: []
    }
  },
  created () {
    // 家庭&设备总数
    this.familyDeviceList = this.familyDevice.familyDevice
  },
  mounted () {
    this.getStartData()
  },
  methods: {
    getRefresh (arr) {
      // console.log('家庭&设备总数')
      this.familyDeviceList = arr
      this.getStartData()
    },
    getStartData () {
      this.familycount = []
      this.devicecount = []
      this.zonename = []
      for (let i = 0; i < this.familyDeviceList.length; i++) {
        if (this.familyDeviceList[i].familycount > 0 || this.familyDeviceList[i].devicecount > 0) {
          this.familycount.push(this.familyDeviceList[i].familycount)
          this.devicecount.push(this.familyDeviceList[i].devicecount)
          this.zonename.push(this.familyDeviceList[i].zonename)
        }
      }
      let vm = this
      setTimeout(() => {
        vm.getChartData()
      }, 100)
    },
    getChartData () {
      if (this.zonename.length === 0) {
        return
      }
      let chart = this.$echarts.init(this.$refs.wrap)
      if (this.familycount.length < 8) {
        chart.setOption({
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            top: '3%',
            left: '4%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          legend: {
            data: ['家庭总数', '设备总数'],
            textStyle: {
              color: '#ffffff'
            }
          },
          xAxis: [
            {
              type: 'category',
              axisLine: {
                lineStyle: {
                  color: '#7fd4ff',
                  width: 1
                }
              },
              data: this.zonename,
              axisPointer: {
                type: 'shadow'
              },
              axisLabel: { // X轴文字倾斜
                interval: 0,
                rotate: 20
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLine: {
                lineStyle: {
                  color: '#7fd4ff',
                  width: 1 // 这里是为了突出显示加上的
                }
              },
              name: '',
              min: 0,
              // max: 250,
              // interval: 50,
              axisLabel: {
                formatter: '{value}'
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: '#182f4d',
                  width: 1 // 这里是为了突出显示加上的
                }
              }
            }
          ],
          series: [
            {
              name: '家庭总数',
              type: 'bar',
              data: this.familycount,
              barWidth: 12,
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                      {offset: 0, color: '#19f1ec'},
                      {offset: 1, color: '#19f1ec00'}
                    ]
                  )
                }
              }
            },
            {
              name: '设备总数',
              type: 'bar',
              data: this.devicecount,
              barWidth: 12,
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                      {offset: 0, color: '#e57300'},
                      {offset: 1, color: '#e5730000'}
                    ]
                  )
                }
              }
            }
          ]
        })
      } else {
        chart.setOption({
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: ['家庭总数', '设备总数'],
            textStyle: {
              color: '#ffffff'
            }
          },
          xAxis: [
            {
              type: 'category',
              axisLine: {
                lineStyle: {
                  color: '#7fd4ff',
                  width: 1
                }
              },
              data: this.zonename,
              axisPointer: {
                type: 'shadow'
              },
              axisLabel: { // X轴文字倾斜
                interval: 0,
                rotate: 20
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLine: {
                lineStyle: {
                  color: '#7fd4ff',
                  width: 1 // 这里是为了突出显示加上的
                }
              },
              name: '',
              min: 0,
              // max: 250,
              // interval: 50,
              axisLabel: {
                formatter: '{value}'
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: '#182f4d',
                  width: 1 // 这里是为了突出显示加上的
                }
              }
            }
          ],
          series: [
            {
              name: '家庭总数',
              type: 'bar',
              data: this.familycount,
              barWidth: 12,
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                      {offset: 0, color: '#19f1ec'},
                      {offset: 1, color: '#19f1ec00'}
                    ]
                  )
                }
              }
            },
            {
              name: '设备总数',
              type: 'bar',
              data: this.devicecount,
              barWidth: 12,
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                      {offset: 0, color: '#e57300'},
                      {offset: 1, color: '#e5730000'}
                    ]
                  )
                }
              }
            }
          ],
          dataZoom: [
            {
              type: 'slider',
              show: true,
              start: 0,
              end: 49,
              handleSize: 8
              // textStyle: {
              //   color: '#ccd7d7'
              // }
            }
          ]
        })
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/monitoring/bigComponents/indexFamilyDevice.vue